/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CancelFeedbackRequestReasonCode = typeof CancelFeedbackRequestReasonCode[keyof typeof CancelFeedbackRequestReasonCode];


export const CancelFeedbackRequestReasonCode = {
  no_longer_hiring: 'no_longer_hiring',
  switching_tool: 'switching_tool',
  no_budget: 'no_budget',
  not_enough_value: 'not_enough_value',
  missing_features: 'missing_features',
  too_expensive: 'too_expensive',
  other: 'other',
} as const;
